<template>
	<div :id="uid" :variant="variant" class="role-card">
		<div class="role-card__status" :id="`${uid}_status`">
			<NotificationIcon
				:variant="notificationVariantIcon"
				ref="tooltipStatusRef"
				@mouseenter="tooltipStatusVisible = true"
				@focus="tooltipStatusVisible = true"
				@mouseleave="tooltipStatusVisible = false"
				@blur="tooltipStatusVisible = false"
			/>
			<Tooltip
				:text="rolStatus"
				:trackedRefName="'tooltipStatusRef'"
				:display="tooltipStatusVisible"
				:offset="[4, 4]"
				position="top-start"
			/>
		</div>
		<div class="role-card__main" :id="`${uid}_main`">
			{{ role.role }}
			<div v-if="showTagLabelConsultantType">
				<TagLabel message="Consultant Role" :state="'secondary-3'" />
			</div>
		</div>

		<ActionsSet
			class="role-card__actions"
			:id="`${uid}_action`"
			:variant="variant"
			:options="actions"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import NotificationIcon from '@/components/notifications/notification-icon/notification-icon';
import Tooltip from '@/components/shells/tooltip/tooltip';
import TagLabel from '@/components/visual/tag-label';

export default {
	name: 'RoleCard',
	components: {
		ActionsSet,
		TagLabel,
		NotificationIcon,
		Tooltip
	},
	data() {
		return {
			tooltipStatusVisible: false
		};
	},
	props: {
		role: {
			type: Object,
			default: () => {}
		}
	},

	computed: {
		hasUpdatePermission() {
			return this.validatePermission('roles.update');
		},
		disableDelete() {
			return this.role.canDelete !== true || !this.hasDeletePermission;
		},
		hasDeletePermission() {
			return this.validatePermission('roles.delete');
		},
		actions() {
			return [
				{
					id: 1,
					action: {
						path: this.$route.path,
						query: {
							roleId: this.role.roleId
						}
					},
					disabled: !this.hasUpdatePermission,
					iconClass: 'icon icon-manage',
					label: 'Settings',
					title: !this.hasUpdatePermission
						? "You don't have permission to perform this action."
						: 'Select to go to role Setting.',
					type: 'router-link',
					visible: true
				},
				{
					id: 2,
					action: {
						path: `/roles/${this.role.roleId}/history`,
						params: {
							changedEntityId: this.role.roleId
						}
					},
					disabled: false,
					iconClass: 'icon icon-history',
					label: 'History',
					title: 'Select to go to role history.',
					type: 'router-link',
					visible: true
				},
				{
					id: 3,
					action: this.removeRole,
					disabled: this.disableDelete,
					iconClass: 'icon icon-delete-glenn',
					label: 'Remove',
					title: !this.hasDeletePermission
						? "You don't have permission to perform this action."
						: this.role.canDelete !== true
						? 'This role cannot be deleted because it’s in use by an active user.'
						: 'Select to remove role.',
					toolTip: '',
					type: 'anchor',
					visible: false // this should be true when this option is approved
				}
			];
		},
		showTagLabelConsultantType() {
			return this.role.clientId === 'vue-support-external';
		},
		rolStatus() {
			if (!this.role.active) {
				return 'Inactive';
			}
			return 'Active';
		},
		notificationVariantIcon() {
			if (!this.role.active) {
				return 'inactive';
			}
			return 'positive';
		}
	},
	methods: {
		removeRole() {
			this.$emit('remove-rol', { ...this.role });
		}
	}
};
</script>

<style lang="scss">
/**
    * Role Card
	* Can use SCSS variables = TRUE
	* [Table of Contents]
    *
    * BASE
    * BASE TABLET-UP
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
@import '@/scss/5-objects/_cards.scss';

.role-card {
	@include card;
	gap: $gutter-lg;
	display: grid;
	grid-template-columns: auto 1fr auto;

	&__main {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		@include heading('md');
		text-transform: capitalize;
		gap: $gutter-sm;
	}
	&__actions {
		margin-left: auto;
	}
}
</style>
